import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey:            "AIzaSyDtMaTl6RqtfsUbpUh8QFu3p887DOkUEfo",
  authDomain:        "vibe-5711f.firebaseapp.com",
  projectId:         "vibe-5711f",
  storageBucket:     "vibe-5711f.firebasestorage.app",
  messagingSenderId: "123919379323",
  appId:             "1:123919379323:web:883a11b3fbb7ae714fabde"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db   = getFirestore(app);

export const SUPABASE_URL  = 'https://opchlghdjrjiglajpfhs.supabase.co';
export const SUPABASE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9wY2hsZ2hkanJqaWdsYWpwZmhzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODE0NDQ1MjYsImV4cCI6MjA5NzAyMDUyNn0.T-W-rakEPIweGvQRaeDm87jcGrBJrk9oUM3tUufihuo';
